import { render, staticRenderFns } from "./Mantra.vue?vue&type=template&id=7c869342&scoped=true&"
import script from "./Mantra.vue?vue&type=script&lang=ts&"
export * from "./Mantra.vue?vue&type=script&lang=ts&"
import style0 from "./Mantra.vue?vue&type=style&index=0&id=7c869342&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c869342",
  null
  
)

export default component.exports